module.exports = __webpack_public_path__ + "media/lmb_pano.725e655e.mp4";